import { render } from "./MobileSidebar.vue?vue&type=template&id=0aa85552&scoped=true"
import script from "./MobileSidebar.vue?vue&type=script&lang=js"
export * from "./MobileSidebar.vue?vue&type=script&lang=js"

import "./MobileSidebar.vue?vue&type=style&index=0&id=0aa85552&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa85552"]])

export default __exports__